import { styled } from '@mui/system'
import { Grid } from "@mui/material";
import AppBar from "../components/AppBar";


interface Props {
}

const SettingHelp: React.FC<Props>=({})=>{

    const Main = styled('main')(({ theme }) => ({ }));
    const eccuEmailAddress = process.env.REACT_APP_ECCU_EMAIL

    const handleAccodionClick =(id: string, id2: string)=>{
        
        document.getElementById('setting-help-btn1')?.classList.add('setting-btn-switch')
        document.getElementById(id2)?.classList.add('settings-profile-show')
    }

 
    
    return (
        <Main id="content">
            <AppBar />

            <section className="container">

                <ul className="ben-page-nav ben-page-nav-tabs" id="PageNavigator">
                    <li className="ben-page-nav-item">
                        <a className="ben-page-nav-link active">Profile</a>
                    </li>
                </ul>


                <div className="ben-groom-panel">
                    <div style={{paddingTop: '1.5rem'}}>


                        <ul className="setting-nav setting-nav-tabs" id="setting-setTab" role="tablist">
                            <li className="setting-nav-item">
                                <a className="setting-nav-link" href="/settings/profile"><span className="setting-user-icon"></span>Profile</a>
                            </li>
                            <li className="setting-nav-item">
                                <a className="setting-nav-link" href="/settings/account-management"><span className="setting-credit-icon"></span>Account Management</a>
                            </li>
                            <li className="setting-nav-item">
                                <a className="setting-nav-link" href="/settings/legal"><span className="setting-smartshield"></span>Legal</a>
                            </li>
                            <li className="setting-nav-item">
                                <a className="setting-nav-link active" href="/settings/help"><span className="setting-bigedit"></span>Help &amp; Support</a>
                            </li>
                        </ul>
                    </div>



                    <Grid container style={{justifyContent: 'center'}}>
                        <Grid item style={{padding: '0 15px'}} xs={12} lg={8.5}>
                            <div id="settings-accordion">
                                <div className="setting-card">

                                <div onClick={()=>handleAccodionClick("setting-help-btn1", 'collapseHelp')} className="settings-card-header" id="settings-help-headingOne">
                                    <h5 style={{marginBottom: '0'}}>
                                        <button id="setting-help-btn1" className="btn btn-link setting-hover-color-change">Chat with us</button>
                                        <div className="bus-down"></div>
                                    </h5>
                                </div>


                                
                                    
                                <div id="collapseHelp" className="settings-profile-dont-show">
                                    <div className="settings-card-body">
                                        <Grid container>
                                            <Grid item style={{padding: '0 15px'}} xs={12}>
                                                <p style={{fontSize: '1rem', color: '#111', }}>Send Elite Community Support Team an email {eccuEmailAddress}</p>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>


                                    {/*  */}

                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>




            </section>

        </Main>
    )
}

export default SettingHelp